import * as HttpService from "../../../../service/HttpService";


/**
 *查询运动员档案列表
 */
export const queryAthleteList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/queryAthleteList", params);
};

/**
 *添加运动员档案
 */
export const addAthleteFiles = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/addAthleteFiles", params);
};

/**
 *查询运动员档案详情
 */
export const queryAthleteDetails = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/queryAthleteDetails", params);
};

/**
 *修改运动员档案
 */
export const editAthleteFiles = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/editAthleteFiles", params);
};

/**
 * 删除运动员档案
 */
export const deleteAthleteFiles = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/deleteAthleteFiles",params);
};

/**
 *批量导入运动员档案
 */
export const importExcel = (params) => {
    return HttpService.postForm(HttpService.DOMAIN + "/athleteFiles/importExcel", params);
};


/**
 *查询所属地址
 */
export const getFuzzyBuildingOrFloorTree = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/agEnergyCostIndex/getFuzzyBuildingOrFloorTree");
};

/**
 *查询用户名称
 */
export const queryUserOnAdd = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/athleteFiles/queryUserOnAdd", params);
};